import React from 'react';
import css from './css.module.less';
import { EPreviewSize } from 'src/types/common/SalesChannel';
import { max, get } from 'lodash';
import emit from 'src/tools/event';
import { onResizing } from 'src/tools/contentModulesFieldName';
const Wrapper = (props) => {
  const { breakpoint } = props;
  //const []=
  const [h, setH] = React.useState<any>(0);

  const handleOnResize = () => {
    const p = `${props.id}_${EPreviewSize.WIDE}`;
    const t = `${props.id}_${EPreviewSize.TABLET}`;
    const m = `${props.id}_${EPreviewSize.MOBILE}`;
    const pT = document.getElementById(p);
    const tT = document.getElementById(t);
    const mT = document.getElementById(m);
    const pH: number = get(pT, 'offsetHeight'); //pT.offsetHeight;
    const tH = get(tT, 'offsetHeight');
    const mH = get(mT, 'offsetHeight');
    const maxHeigh = max([pH, tH, mH]);
    if (h !== maxHeigh) {
      setH(maxHeigh);
    } //return maxHeigh;
  };

  React.useEffect(() => {
    if (!props.id) return;
    emit.on(onResizing, handleOnResize);
    const p = `${props.id}_${EPreviewSize.WIDE}`;
    const t = `${props.id}_${EPreviewSize.TABLET}`;
    const m = `${props.id}_${EPreviewSize.MOBILE}`;
    const pT = document.getElementById(p);
    const tT = document.getElementById(t);
    const mT = document.getElementById(m);
    const resizeObserver = new ResizeObserver((entries) => {
      const pT = document.getElementById(p);
      const tT = document.getElementById(t);
      const mT = document.getElementById(m);
      const pH: number = get(pT, 'offsetHeight'); //pT.offsetHeight;
      const tH = get(tT, 'offsetHeight');
      const mH = get(mT, 'offsetHeight');
      const maxHeigh = max([pH, tH, mH]);
      setH(maxHeigh);
      emit.emit(onResizing);
      // Do what you want to do when the size of the element changes
    });
    if (pT && tT && mT) {
      resizeObserver.observe(pT);
      resizeObserver.observe(tT);
      resizeObserver.observe(mT);
    }
    return () => {
      resizeObserver.disconnect();
      emit.removeListener(onResizing, handleOnResize);
    }; // clean up
  }, [props.id, breakpoint]);
  return (
    <div
      className={css.container}
      style={{ minHeight: h }}
      id={`${props.id}_${breakpoint}_wrapper`}>
      <div id={`${props.id}_${breakpoint}`} className={css.innerContainer}>
        <ChildWrapper>{props.children}</ChildWrapper>
      </div>
    </div>
  );
};
export default Wrapper;

const ChildWrapper = React.memo((props) => {
  return <React.Fragment>{props.children}</React.Fragment>;
});
